import logo from '../assets/img/logo.png';
import { FaFacebookSquare, FaTiktok, FaWhatsapp, FaYoutube } from 'react-icons/fa';
import { AiFillInstagram } from 'react-icons/ai';
import { useSiteSettings } from '../contexts/SiteSettingsContext';

export function Contact() {
    // Read contact info from shared context — no extra API call
    const settings = useSiteSettings()
    const phone = settings?.phone || '+972508993111'
    const rawWhatsapp = settings?.whatsapp || settings?.phone || '972508993111'
    const whatsappNumber = rawWhatsapp.replace(/\D/g, '')

    return <section className='contact main-layout full' id='contact'>
        <div className='contact-us-container'>
            <header>
                <h2>נשמח לעמוד לשירותכם</h2>
                <img className='logo' src={logo} alt="לוגו" />
            </header>
            <a href={`tel:${phone}`} className="contact-call-btn">צור קשר</a>
        </div>
        <div className='social-btns-container'>
            <a href="https://www.tiktok.com/@eyalzelig1"
                target="_blank"
                rel="noopener noreferrer"
                aria-label='tiktok'
            >
                <FaTiktok />
            </a>
            <a href="https://www.instagram.com/eyalzelig/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label='instagram'
            >
                <AiFillInstagram />
            </a>
            <a href="https://www.youtube.com/channel/UCbTOpDjIv3o2ZEUvgFsdXjQ"
                target="_blank"
                rel="noopener noreferrer"
                aria-label='youtube'
            >
                <FaYoutube />
            </a>
            <a href="https://www.facebook.com/zeligeyal"
                target="_blank"
                rel="noopener noreferrer"
                aria-label='facebook'
            >
                <FaFacebookSquare />
            </a>
            <a
                href={`https://api.whatsapp.com/send/?phone=${whatsappNumber}&text&type=phone_number&app_absent=0`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label='whatsapp'
            >
                <FaWhatsapp />
            </a>
        </div>
        <div className='mask' />
    </section>
}